import { css } from '@emotion/react';
import { Z_INDEX } from '../../constants/zIndex';

const zoomControlsStyles = {
    container: css({
        position: 'fixed',
        bottom: 142,
        right: 30,
        display: 'none',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'transparent',
        zIndex: Z_INDEX.MAP_CONTROLS,
        borderRadius: '8px',

        '@media (min-width: 600px)': {
            display: 'flex',
        },
    }),
    btnContainerTop: css({
        width: '44px',
        height: '44px',
        backgroundColor: '#ffffff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        borderTopLeftRadius: '8px',
        borderTopRightRadius: '8px',
        borderBottom: '1px solid #EDEDED',
    }),
    btnContainerBottom: css({
        width: '44px',
        height: '44px',
        backgroundColor: '#ffffff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        borderBottomLeftRadius: '8px',
        borderBottomRightRadius: '8px',
    }),
};

export default zoomControlsStyles;
